(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentReviewControllers')
        .controller('RiskSelfAssessmentReviewRiskRatingsController', Controller);

    Controller.$inject = ['$scope', 'commonRiskSelfAssessmentService'];

    function Controller($scope, commonRiskSelfAssessmentService) {

        $scope.probabilityRatings = _.filter($scope.ctrlCtxt.criterias, { RiskLookupAssessmentTypeName: 'Probability' });
        $scope.severityRatings    = _.filter($scope.ctrlCtxt.criterias, { RiskLookupAssessmentTypeName: 'Severity' });
        $scope.mitigationRatings  = _.filter($scope.ctrlCtxt.criterias, { RiskLookupAssessmentTypeName: 'Mitigation' });
        $scope.overallRatings     = _.filter($scope.ctrlCtxt.criterias, { RiskLookupAssessmentTypeName: 'Overall' });

        initAssessmentRatings();
        initSelectedRatings();
        initPreviousAssessmentRatings();

        // Set final probability rating
        $scope.setFinalProbabilityRating = function (rating) {
            if ($scope.riskToReview.Assessment.FinalProbabilityCode === rating.Code) {
                return;
            }

            $scope.riskToReview.Assessment.FinalProbabilityCode = rating.Code;
            $scope.selectedFinalProbabilityRating = rating;
            setOverallRatingCodes();

            setHaveRatingsBeenModified();
            setIsEditingOverrideExplanation();
        };

        // Show final probability rating
        $scope.showFinalProbabilityRating = function () {
            return $scope.riskToReview.Assessment.FinalProbabilityCode !==
                        $scope.riskToReview.Assessment.InitialProbabilityCode;
        };

        // Set final severity rating
        $scope.setFinalSeverityRating = function (rating) {
            if ($scope.riskToReview.Assessment.FinalSeverityCode === rating.Code) {
                return;
            }

            $scope.riskToReview.Assessment.FinalSeverityCode = rating.Code;
            $scope.selectedFinalSeverityRating = rating;
            setOverallRatingCodes();

            setHaveRatingsBeenModified();
            setIsEditingOverrideExplanation();
        };

        // Show final severity rating
        $scope.showFinalSeverityRating = function () {
            return $scope.riskToReview.Assessment.FinalSeverityCode !==
                        $scope.riskToReview.Assessment.InitialSeverityCode;
        };

        // Set final mitigation rating
        $scope.setFinalMitigationRating = function (rating) {
            if ($scope.riskToReview.Assessment.FinalMitigationCode === rating.Code) {
                return;
            }

            $scope.riskToReview.Assessment.FinalMitigationCode = rating.Code;
            $scope.selectedFinalMitigationRating = rating;
            setOverallRatingCodes();

            setHaveRatingsBeenModified();
            setIsEditingOverrideExplanation();
        };

        // Show final mitigation rating
        $scope.showFinalMitigationRating = function () {
            return $scope.riskToReview.Assessment.FinalMitigationCode !==
                        $scope.riskToReview.Assessment.InitialMitigationCode;
        };

        // Set final overall rating
        $scope.setFinalOverallRating = function (rating) {
            $scope.riskToReview.Assessment.FinalIsOverriden = true;
            $scope.riskToReview.Assessment.FinalOverallCode = rating.Code;
            $scope.finalDepartmentOverallCriteria = rating;

            setHaveRatingsBeenModified();
            setIsEditingOverrideExplanation();
        };

        // Set Have Ratings Been Modified
        function setHaveRatingsBeenModified() {
            $scope.ctrlCtxt.haveRatingsBeenModified =
                $scope.showFinalProbabilityRating() ||
                $scope.showFinalSeverityRating() ||
                $scope.showFinalMitigationRating() ||
                $scope.riskToReview.Assessment.FinalOverallCode !== $scope.riskToReview.Assessment.InitialOverallCode;
        }
        setHaveRatingsBeenModified();

        // Have ratings been modified?
        $scope.haveRatingsBeenModified = function () { return $scope.ctrlCtxt.haveRatingsBeenModified;};

        // Edit override explanation
        $scope.editOverrideExplanation = function () {
           $scope.ctrlCtxt.isEditingOverrideExplanation = true;
        };

        // Cancel edit override explanation
        $scope.cancelEditOverrideExplanation = function () {
            initAssessmentRatings();
           $scope.ctrlCtxt.isEditingOverrideExplanation = false;
        };

        // Helpers
        function getSelectedRating(ratingCode, ratings) {
            var naRating = { Color: 'default', Name: 'N/A' };

            if (!ratingCode) { return naRating }

            return _.find(ratings, { Code: ratingCode });
        }

        function initSelectedRatings() {
            $scope.selectedProbabilityRating = getSelectedRating(
                $scope.riskToReview.Assessment.InitialProbabilityCode,
                $scope.probabilityRatings
            );

            $scope.selectedFinalProbabilityRating = getSelectedRating(
                $scope.riskToReview.Assessment.FinalProbabilityCode,
                $scope.probabilityRatings
            );

            $scope.selectedSeverityRating = getSelectedRating(
                $scope.riskToReview.Assessment.InitialSeverityCode,
                $scope.severityRatings
            );

            $scope.selectedFinalSeverityRating = getSelectedRating(
                $scope.riskToReview.Assessment.FinalSeverityCode,
                $scope.severityRatings
            );

            $scope.selectedMitigationRating = getSelectedRating(
                $scope.riskToReview.Assessment.InitialMitigationCode,
                $scope.mitigationRatings
            );

            $scope.selectedFinalMitigationRating = getSelectedRating(
                $scope.riskToReview.Assessment.FinalMitigationCode,
                $scope.mitigationRatings
            );

            $scope.computedOverallCriteria = getSelectedRating(
                $scope.riskToReview.Assessment.InitialComputedOverallCode,
                $scope.overallRatings
            );

            $scope.finalComputedOverallCriteria = getSelectedRating(
                $scope.riskToReview.Assessment.FinalComputedOverallCode,
                $scope.overallRatings
            );

            $scope.departmentOverallCriteria = getSelectedRating(
                $scope.riskToReview.Assessment.InitialOverallCode,
                $scope.overallRatings
            );

            $scope.finalDepartmentOverallCriteria = getSelectedRating(
                $scope.riskToReview.Assessment.FinalOverallCode,
                $scope.overallRatings
            );
        }

        function setOverallRatingCodes() {
            if (!$scope.riskToReview.Assessment.FinalSeverityCode ||
                !$scope.riskToReview.Assessment.FinalProbabilityCode ||
                !$scope.riskToReview.Assessment.FinalMitigationCode) {

                return;
            }

            commonRiskSelfAssessmentService
                    .computeOwnerOverallCriteria(
                        $scope.riskToReview.Assessment.FinalSeverityCode,
                        $scope.riskToReview.Assessment.FinalProbabilityCode,
                        $scope.riskToReview.Assessment.FinalMitigationCode
                    )
                    .then(function (computedOverallCriteria) {
                        $scope.riskToReview.Assessment.FinalComputedOverallCode = computedOverallCriteria.Code;
                        $scope.riskToReview.Assessment.FinalOverallCode         = computedOverallCriteria.Code;
                        $scope.finalDepartmentOverallCriteria = computedOverallCriteria;
                    });
        }

        function initAssessmentRatings() {
            if ($scope.riskToReview.Assessment.InitialIndicatorsConfirmedAsIs === false) return;
            //if ($scope.riskToReview.Assessment.HasFinalAssessorReviewed) return;

            $scope.riskToReview.Assessment.FinalProbabilityCode =
                    $scope.riskToReview.Assessment.InitialProbabilityCode;

            $scope.riskToReview.Assessment.FinalSeverityCode =
                    $scope.riskToReview.Assessment.InitialSeverityCode;

            $scope.riskToReview.Assessment.FinalMitigationCode =
                    $scope.riskToReview.Assessment.InitialMitigationCode;

            $scope.riskToReview.Assessment.FinalComputedOverallCode =
                    $scope.riskToReview.Assessment.InitialComputedOverallCode;

            $scope.riskToReview.Assessment.FinalOverallCode =
                    $scope.riskToReview.Assessment.InitialOverallCode;

            $scope.riskToReview.Assessment.FinalIsOverriden =
                    $scope.riskToReview.Assessment.InitialIsOverrideOverall;
        }

        function initPreviousAssessmentRatings() {

            if (!$scope.riskToReview.PreviousAssessments ||
                $scope.riskToReview.PreviousAssessments.length === 0) {
                return;
            }

            $scope.previousAssessment = $scope.riskToReview.PreviousAssessments[0];

            $scope.previousProbabilityRating = getSelectedRating(
                $scope.previousAssessment.FinalProbabilityCode,
                $scope.probabilityRatings
             );

            $scope.previousSeverityRating = getSelectedRating(
                $scope.previousAssessment.FinalSeverityCode,
                $scope.severityRatings
            );

            $scope.previousMitigationRating = getSelectedRating(
                $scope.previousAssessment.FinalMitigationCode,
                $scope.mitigationRatings
            );

            $scope.previousComputedOverallCriteria = getSelectedRating(
                $scope.previousAssessment.FinalComputedOverallCode,
                $scope.overallRatings
            );

            $scope.previousDepartmentOverallCriteria = getSelectedRating(
                $scope.previousAssessment.FinalOverallCode,
                $scope.overallRatings
            );
        }

        function setIsEditingOverrideExplanation() {
            if (!$scope.haveRatingsBeenModified() &&
                    !$scope.riskToReview.Assessment.FinalOverrideExplanation) {
               $scope.ctrlCtxt.isEditingOverrideExplanation = false;
            } else {
               $scope.ctrlCtxt.isEditingOverrideExplanation = true;
            }
        }
     
    }
})();